import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function ItemDetalleSucursal(props) {
    const { sucursal, fecha, idUsuario, regional,actualizar,idProducto } = props;
    const [error, setError] = useState({});
    const [datos, setDatos] = useState([]);
    const [inventario,setInventario] = useState(null);
    const [cargando, setCargando] = useState(false);
    function getInventario() {
        fetch(`${server}/reporte/getMovimientoPolloHisto`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ...sucursal, idAlmacen: 1, fecha, idUsuario
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {                   
                    var datos = []
                    var datosinv = []
                    if(idProducto==2){
                        datos = data.ok.suc.filter((dt) => [105].indexOf(parseInt(dt.ID_PROD_ORIGINAL)) !== -1)
                        datosinv = data.ok.inv.filter((dt)=> [105].indexOf(parseInt(dt.ID_PRODUCTO)) !== -1)
                    }
                    console.log(datosinv[0]);
                    setInventario(datosinv[0]);
                    setDatos(datos);
                    console.log(datos);
                } else {
                    setError({ error: 'ERR' })
                }
                setCargando(false);
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function getResultado(valor){
        var result = valor.INICIAL_ORIGINAL+valor.INGRESOS_ORIGINAL-valor.EGRESOS_ORIGINAL-valor.VENTAS_ORIGINAL-valor.RESERVAS_ORIGINAL
        return result.toFixed(1)
    }
    useEffect(() => {
        setError({});
        setCargando(true);
        getInventario()
    }, [actualizar])
    return (
        <tr>
            <th style={{ fontSize: '19px', width: '100px' }}>{sucursal.SUCURSAL}</th>
            {cargando && [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => {
                return (
                    <td className='text-center' key={item} style={{ fontSize: '19px', width: '100px' }}><i className="fa-solid fa-spinner fa-spin"></i></td>
                )
            })}
            {!cargando && error.error !== undefined &&
                [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => {
                    return (
                        <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>
                    )
                })}
            {!cargando && error.error === undefined && datos.length!=0 &&
            datos.map((item,index)=>{
                return(
                    <>
                        <td className='text-center'>{item.INICIAL_ORIGINAL}</td>
                        <td className='text-center'>{item.INGRESOS_ORIGINAL}</td>
                        <td className='text-center'>{item.EGRESOS_ORIGINAL}</td>
                        <td className='text-center'>{item.RESERVAS_ORIGINAL}</td>
                        <td className='text-center'>{item.TRANSITO_ORIGINAL}</td>
                        <td className='text-center'>{item.VENTAS_ORIGINAL}</td>
                        <td className='text-center'>{getResultado(item)}</td>
                        {inventario!=null&&<td className='text-center'>{`${inventario.CANTIDAD}`}</td>}
                        {(inventario==null||inventario==undefined)&&<td className='text-center'>0</td>}
                        {(inventario==null||inventario==undefined)&&<td className='text-center'>0</td>}
                        {inventario!=null&&<td className='text-center'>{(getResultado(item)-inventario.CANTIDAD).toFixed(1)}</td>}
                    </>
                )
            })}
        </tr>
    )
}

export default ItemDetalleSucursal